import React from 'react';
import { useState } from "react";
import VideoCapture from "./VideoCapture/VideoCapture";
import ImageCapture from "./ImageCapture/ImageCapture";
import "./BarcodeScanner10.css";

enum Modes {
  VIDEO_CAPTURE = "video",
  IMAGE_CAPTURE = "image",
}

interface BarcodeScanner10Props {
  onCapture?: (result: string) => void;
}

const BarcodeScanner10 = ({ onCapture }: BarcodeScanner10Props) => {
  const [mode, setMode] = useState(Modes.VIDEO_CAPTURE);

  const handleCapture = (result: string) => {
    onCapture && onCapture(result);
  }

  // const showVideoCapture = () => setMode(Modes.VIDEO_CAPTURE);

  // const showImageCapture = () => setMode(Modes.IMAGE_CAPTURE);

  return (
    <div className="hello-world-page">
      {/* <div className="title">
        <h2 className="title-text">Hello World for React</h2>
      </div>
      <div className="buttons-container">
        <button
          style={{
            backgroundColor: mode === Modes.VIDEO_CAPTURE ? "rgb(255,174,55)" : "white",
          }}
          onClick={showVideoCapture}
        >
          Decode Video
        </button>
        <button
          style={{
            backgroundColor: mode === Modes.IMAGE_CAPTURE ? "rgb(255,174,55)" : "white",
          }}
          onClick={showImageCapture}
        >
          Decode Image
        </button>
      </div> */}
      <div className="container">
        {mode === Modes.VIDEO_CAPTURE && <VideoCapture showResultsUi={false} onCapture={handleCapture} />}
        {mode === Modes.IMAGE_CAPTURE && <ImageCapture />}
      </div>
    </div>
  );
}

export default BarcodeScanner10;
